import { render } from "./cash.vue?vue&type=template&id=997012ca&scoped=true"
import script from "./cash.vue?vue&type=script&lang=js"
export * from "./cash.vue?vue&type=script&lang=js"

import "./cash.vue?vue&type=style&index=0&id=997012ca&lang=less&scoped=true"

import exportComponent from "G:\\小程序\\OT ASAR\\vue后台\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-997012ca"]])

export default __exports__